/*
* Copyright 2026 Tecnalia, Basque Research & Technology Alliance (BRTA)
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*
*  SPDX-License-Identifier: Apache-2.0
*/

import { HttpDeleteParticipantService } from "./http-delete-participant.service";
import { catchError, map, Observable, throwError } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({
  	providedIn: 'root'
})

export class DeleteParticipantService {

    constructor(
        private httpDeleteParticipantService: HttpDeleteParticipantService
    ) { }

    public deleteParticipant$(participantID: string): Observable<boolean> {

        return this.httpDeleteParticipantService.deleteParticipant$(participantID).pipe(
            map(() => true),
            catchError(err => {
                console.error('[DeleteParticipantService] Error deleting the participant', err);
                return throwError(() => new Error('An error has occurred while trying to delete the participant'));
            })
        );

    }

}